/** 並べ替えカードの状態操作と文言（card-schema.md §3.3、judge.md §4.2） */
import { shuffleById, type ParsonsCard } from '../../lib/cards';
import type { GradeResult } from '../types';

export interface ParsonsLine {
  /** lines + distractors を連結した列での添字（同じ文字列の行があっても一意） */
  key: number;
  text: string;
}

/** 出題時の並び（id を種にした決定的なシャッフル。正解の並びそのものにはしない） */
export function parsonsLines(
  card: Pick<ParsonsCard, 'id' | 'lines' | 'distractors'>,
): ParsonsLine[] {
  const all = [...card.lines, ...(card.distractors ?? [])];
  return shuffleById(card.id, all, true).map(({ item, index }) => ({ key: index, text: item }));
}

/** 保存済みの回答（文字列の列）を key の列に戻す。同じ文字列は出題順で先のものから当てる */
export function keysFromLines(pool: readonly ParsonsLine[], lines: readonly string[]): number[] {
  const used = new Set<number>();
  const out: number[] = [];
  for (const text of lines) {
    const hit = pool.find((l) => l.text === text && !used.has(l.key));
    if (hit) {
      used.add(hit.key);
      out.push(hit.key);
    }
  }
  return out;
}

/** 配列の要素 from を to の位置へ動かした新しい配列 */
export function moveItem<T>(arr: readonly T[], from: number, to: number): T[] {
  const out = [...arr];
  const [x] = out.splice(from, 1);
  if (x === undefined) return out;
  out.splice(Math.max(0, Math.min(to, out.length)), 0, x);
  return out;
}

const AGAIN = 'このカードはあとでもう一度出ます。';
const strip = (s: string) => s.replace(/[ \t]+$/, '');

export function parsonsMessage(
  card: Pick<ParsonsCard, 'lines' | 'distractors'>,
  answer: readonly string[],
  correct: boolean,
): GradeResult {
  if (correct) return { verdict: 'AC', message: '正しい順に並びました。' };
  const lineSet = new Set(card.lines.map(strip));
  const usedDistractor = answer.some((l) => !lineSet.has(strip(l)));
  const fact = usedDistractor
    ? '使わない行が入っています。'
    : answer.length < card.lines.length
      ? '使っていない行があります。'
      : '並び順が異なります。';
  return { verdict: 'WA', message: `${fact}正しい並びを表示します。${AGAIN}` };
}
